export class GermanService {

  //#################################################################################
  //
  // This service holds hashmap containing all german strings used in our platform
  // When translating, please keep keys (first argument) same, while
  // adapting the values (seconds argument).
  //
  //#################################################################################

  private lang = new Array();

  constructor() {
    //define strings for missing or excessive number of arguments
    this.populateMissingOrExcessiveArguments();

    //populate all bracket-related errors
    this.populateBracketErrors("Farbdefinition");

    //define static string that do not need to be translated
    this.populateStaticStrings();

    //define strings related to login
    this.defineLoginStrings();

    //define key-value pairs (keys are fixed, please adjust values only on the right)
    this.define("yes", "Ja");
    this.define("no", "Nein");
    this.define("menu", "Menü");
    this.define("saveFile", "Datei speichern");
    this.define("loadFile", "Datei laden");
    this.define("saveCanvas", "Bild speichern");
    this.define("fullscreen", "Start/Stop Vollbildmodus");
    this.define("newfeatures", "Was ist neu?");
    this.define("Cheatsheet", "Befehlsübersicht");
    this.define("background", "Hintergrundbilder");

    //language-related strings
    this.define("language", "Wähle eine Sprache");

    //User Interface: history, input and general UI
    this.define("previousCommands", "Vorherige Befehle:");
    this.define("input", "EINGABE: ");
    this.define("definitionInInput", "Rufe Befehle aus dem Editor auf ohne TO und END");
    this.define("timeout", "Die Berechnung dauert aussergewöhnlich lange - weiterfahren?");
    this.define("errorineditor", "Korrigiere zuerst die Fehler im Editor");
    this.define("enterCommand", "Befehle hier eingeben");
    this.define("errorInInput", "Befehl nicht verstanden. War da etwas falsch?");
    this.define("stopExecution", "Möchtest du die laufende Berechnung abbrechen?")
    this.define("cmdAlreadyFinished", "Befehl ist bereits zu Ende!");
    this.define("hoppla", "Hoppla...");
    this.define("cancel", "abbrechen");
    this.define("continue", "fortfahren");

    //boolean values
    this.define("true", "wahr");
    this.define("false", "falsch");

    //status update while execution
    this.define("parsingEditor", "Befehl einlesen...");
    this.define("executingVisitor", "Berechne Resultat...");
    this.define("stoppingVisitor", "Breche Befehl ab...");
    this.define("init", "Initialisieren...")
    this.define("checking", "Prüfe Editor...");

    //syntax checking: program declaration
    this.define("missingTo", "Fehlendes 'to'");
    this.define("missingEnd", "Fehlendes 'end'");
    this.define("manyTos", "Zu viele 'to'");
    this.define("manyEnds", "Zu viele 'end'");
    this.define("maybeTo", "'to' ist falsch geschrieben");
    this.define("misspelledEnd", "'end' ist falsch geschrieben");
    this.define("noName", "Dein Programm braucht einen Namen");
    this.define("noToNoName", "Es fehlt ein 'to'");
    this.define("nameTO", "Du darfst dein Programm nicht 'to' nennen");
    this.define("nameEND", "Du darfst dein Programm nicht 'end' nennen");
    this.define("nameCMD", "Diesen Namen gibt es in Logo bereits");
    this.define("nameFUNC", "Diesen Namen gibt es in Logo bereits");
    this.define("nosuchmethod", "Es gibt kein Programm mit dem Namen: ");
    this.define("noEOL", "Beginne deine Befehle auf der nächsten Zeile");
    this.define("noEOLbeforeEND", "'end' und andere Befehle können nicht auf derselben Zeile stehen");
    this.define("eolAfterTo", "'to' und der Programm-Namen gehören auf dieselbe Zeile");
    this.define("methodNameWhitespace", "Hast du ein Leerzeichen im Programmnamen?");

    //syntax checking: parameters
    this.define("paramsNoColon", "Fehlt hier der Doppelpunkt vor dem Parameter?");
    this.define("doubleDeclaration", "Dieser Programm-Name wurde schon weiter oben verwendet");
    this.define("eolBeforeParams", "Alle Parameter müssen auf der gleichen Zeile stehen wie der Programm-Name");
    this.define("paramsOneLine", "Alle Parameter müssen auf der gleichen Zeile stehen");
    this.define("sameParam", "Diesen Parameternamen verwendest du doppelt: ");
    this.define("paramDeclsNotOk", "Lücken zwischen ':' und dem Parameter sind nicht erlaubt");
    this.define("paramDeclNoName", "Fehlender Parametername nach dem Doppelpunkt");

    //syntax checking: colors
    this.define("rgbMissingValues", "Eine Farbe braucht 3 Werte");
    this.define("rgbCommas", "Entferne die Kommas zwischen den Werten");
    this.define("colornameMisspelled", "Tippfehler bei der Farbe. ");
    this.define("noColorWithThisName", "Diese Farbe gibt es nicht: ");

    //syntax checking: blocks and brackets
    this.define("bracketError", "Problem mit den Klammern");
    this.define("squareBracketProblem", "Problem mit den eckigen Klammern");
    this.define("roundBracketProblem", "Problem mit den runden Klammern?");

    //syntax checking: while
    this.define("whileMissingBlock", "Was soll in 'while' wiederholt werden?");
    this.define("whileManyBlocks", "'While' hat nur einen Teil in []. Du hast zu viele.");
    this.define("whileNoArgs", "Nach 'while' fehlen zwei Parameter");

    //syntax checking: repeat
    this.define("repeatMissingExpr", "Wie oft sollen die Befehle bei 'repeat' wiederholt werden?");
    this.define("repeatMissingBlock", "Was soll bei 'repeat' wiederholt?");
    this.define("repeatNoArg", "Nach 'repeat' fehlt eine Zahl und die zu wiederholenden Befehle");
    this.define("repeatNoBrackets", "Es braucht [] Klammern um den Teil der beim 'repeat' wiederholt werden soll");
    this.define("repeatManyBlocks", "Es darf nach 'repeat' nur einen Teil in Klammern stehen");

    //syntax checking: if-else
    this.define("ifNoBlock", "Was soll bei 'if' ausgeführt werden?");
    this.define("ifManyBlocks", "Zu viele Teile [] bei 'if'");
    this.define("ifBrackets", "Klammern bei der 'if'-Bedingung unnötig");
    this.define("ifNoArgs", "Nach 'if' fehlt etwas");

    //syntax checking: make
    this.define("makeNoVal", "Fehlender Wert als zweiter Parameter bei 'make'");
    this.define("makeNoLit", "Fehlende Variablen-Definition (\" und Variablen-Name) als erster Parameter bei 'make'");
    this.define("makeNoArgs", "Nach 'make' fehlt etwas");
    this.define("derefMake", "Verwende ':' statt \" vor dem Parameternamen");
    this.define("makeReverse", "Der Parametername muss vor dem Wert stehen beim Befehl 'make'");
    this.define("makeColon", "Du musst beim 'make' vor der Variable \" statt : verwenden");
    this.define("variableNotDeclared", "Dieser Parameter wurde nicht definiert: ");
    this.define("makeLitNotOk", "Keine Leerzeichen erlaubt nach \"");
    this.define("derefNotOk", "Entferne das Leerzeichen nach dem Doppelpunkt");

    //syntax checking: general error messages
    this.define("extraneousInput", "In diesem Programm gibt es einen Fehler.");
    this.define("noViableAlternative", "Fehlt da vielleicht noch etwas?");
    this.define("didYouMean", "Meintest du vielleicht: ");
    this.define("tooSmall", "Diese Zahl ist zu klein");
    this.define("specialCharacters", "Dieses Zeichen ist nicht erlaubt: ");
    this.define("whitespace", "Fehlende Lücke zwischen benachbarten Befehlen");
    this.define("justExpression", "Fehlender Befehlsname vor dem Parameter");
    this.define("tokenRecognition", "Dieses Zeichen ist nicht erlaubt: ");
    this.define("tooMuch", "Zu viel: ");
    this.define("funcMisspelled", " ist unbekannt");

    // Tooltips in header
    this.define("tooltipButtonStop", "Laufendes Programm stoppen");
    this.define("tooltipButtonDebug", "Programm Schritt für Schritt ausführen");
    this.define("tooltipButtonForward", "Einen Schritt zurück zum letzen Befehl");
    this.define("tooltipButtonBackward", "Nächsten Befehl ausführen");
    this.define("tooltipButtonSpeed", "Geschwindigkeit anpassen");
    this.define("tooltipButtonLanguage", "Sprache ändern");
    this.define("tooltipButtonTurtle", "Schildkröte ändern");

    // Debug control buttons
    this.define("buttonDebugToggle", "Schrittweise");
    this.define("buttonForward", "Vorwärts");
    this.define("buttonBackward", "Rückwärts");

    // Debug watch labels
    this.define("watchPenDown", "Stift unten:");
    this.define("watchErasing", "Radieren:");
    this.define("watchVisible", "Sichtbar:");
    this.define("watchColor", "Stiftfarbe:");
    this.define("watchWidth", "Stiftbreite");
    this.define("watchDirection", "Ausrichtung:");

    // Run time error exceptions
    this.define("exception_division_by_zero", "Die Division durch 0 ist nicht möglich");
    this.define("exception_invalid_argument_asin", "Der Parameter für arcsin muss zwischen -1 und 1 liegen");
    this.define("exception_invalid_argument_acos", "Der Parameter für arccos muss zwischen -1 and 1 liegen");
    this.define("exception_invalid_argument_tan", "Der Parameter für tan darf nicht die Form (0.5 + k) * PI haben");
    this.define("exception_invalid_argument_mod", "Es ist nicht möglich mod n 0 zu berechnen");
    this.define("exception_invalid_argument_colornumber", "Die angegebene Farbnummer existiert nicht: ");
    this.define("exception_invalid_argument_colorname", "Der angegebene Farbname existiert nicht: ");
    this.define("exception_invalid_argument_rgb", "Der angegebene Farbwert ist nicht gültig: ");
    this.define("exception_sqrt_negative_number", "Die Wurzel von negativen Zahlen zu berechnen ist nicht möglich");
    this.define("exception_log10_negative_number", "Den Logarithmus von negativen Zahlen zu berechnen ist nicht möglich");

    // Catching invalid arguments that might lead to unexpected behavior
    this.define("exception_setpw_negative_number", "Eine negative Stiftbreite zu setzen ist nicht möglich");
    this.define("exception_wait_negative_number", "Eine negative Zeit zu warten ist nicht möglich");
    this.define("exception_circle_negative_number", "Einen Kreis mit negativem Radius zu zeichnen ist nicht möglich");

    //quickstart: general text
    this.define("tutorialtype", "Wähle ein Tutorial.");
    this.define("doyouneedhelp", "Brauchst du Hilfe?");
    this.define("firststeps", "Erste Schritte");
    this.define("definenewcommands", "Definiere neue Befehle");
    this.define("debugger", "Schritt-für-Schritt Modus");

    //quickstart: getting started
    this.define("intro1", "Willkommen in XLogoOnline. In diesem Tutorial lernst du, farbige Muster zu programmieren.");
    this.define("intro2", "Schau, die Schildkröte zeichnet ein Mandala! Was wir sehen, ist das Resultat eines Programms.");
    this.define("intro3", "Programme bestehen aus Befehlen. Zwei solche Befehle sind FD und BK (die wir verwenden, um Linien zeichnen). RT und LT drehen die Schildkröte nach rechts oder links.");
    this.define("intro4", "Probier es aus! Klicke ins Feld und bestätige den Befehl mit ENTER");
    this.define("intro5", "Die Schildkröte führt jeden deiner Befehle aus. Das Resultat siehst du hier auf der Zeichenfläche");
    this.define("intro6", "Lösche die Zeichnung mit dem Befehl CS.");
    this.define("intro7", "CS löscht alle Linien und setzt die Schildkröte zurück in die Mitte");
    this.define("intro8", "Progamme können auch aus mehreren Befehlen bestehen. Finde heraus, was hier gezeichnet wird!");
    this.define("intro9", "Alle bereits ausgeführten Programme werden hier der Reihe nach aufgelistet.");
    this.define("intro10", "Mit den PFEIL-TASTEN " + String.fromCharCode(8679) + " und " + String.fromCharCode(8681) + " können frühere Programme (ohne sie nochmals zu schreiben) wieder in die Eingabezeile geladen werden.");
    this.define("intro11", "Was geschieht eigentlich, wenn wir einen Fehler machen?");
    this.define("intro12", "Dieses Programm ist fehlerhaft. Siehst du den Fehler? Teste, was die Schildkröte mit falschen Programmen macht.");
    this.define("intro13", "Die Schildkröte hat die Anweisung nicht verstanden. Anstatt einer Zeichnung erhalten wir einen Hinweis auf den Fehler und dessen Ursache (hier in orange).");
    this.define("intro14", "Los geht's. Viel Spass beim Programmieren!");

    //quickstart: how to use the editor
    this.define("editor1", "In diesem Tutorial zeigen wir dir, wie du neue Befehle definierst und verwendest.");
    this.define("editor2", "Schau dir dieses komplexe Programm an! Wer erratet, was das Programm tut?");
    this.define("editor3", "Was? So ein kompliziertes Programm, bloss um vier Quadrate zu zeichnen?!");
    this.define("editor4", "Kann man das nicht viel einfacher machen, zum Beispiel so?");
    this.define("editor5", "Leider nicht; den Befehl QUADRAT kennt die Schildkröte nämlich nicht... Lasst uns also einen neuen Befehl definieren!");
    this.define("editor6", "Neue Befehle definieren wir hier. Dieses Feld nennen wir Editor.");
    this.define("editor7", "\'TO\' QUADRAT \'END\' definiert einen neuen Befehl mit dem Namen QUADRAT.");
    this.define("editor8", "In demselben Fenster können auch mehrere Befehle definiert werden.");
    this.define("editor9", "Hoppla! Siehst du das rote Kreuz in Zeile 5? Es zeigt an, dass sich auf dieser Zeile ein Fehler versteckt. Was könnte es sein? Derselbe Befehl QUADRAT wurde mehrfach definiert. (Tipp: Nach diesem Tutorial kannst du mit der Maus übers Kreuz fahren und erfährst weitere Details zum Fehler)");
    this.define("editor10", "Was genau soll eigentlich geschehen, wenn der Befehl QUADRAT aufgerufen wird? Wir notieren die entsprechenden Befehle zwischen TO und END");
    this.define("editor11", "Lasst uns testen, was der neue Befehl bewirkt. Was denkst du? Probier es aus.");
    this.define("editor12", "Ein Quadrat, und das mit nur einem einzigen Befehl! Praktisch! Damit lassen sich nun auch kompliziertere Bilder ganz einfach zeichnen...");
    this.define("editor13", "Gratulation! Du hast deinen ersten eigenen Befehl definiert (im Editor) und aufgerufen. Viel Spass beim programmieren!");

    //login service
    this.define("loginButton", "Login");
    this.define("logoutButton", "Logout");
    this.define("registerButton", "Ich bin neu...")
    this.define("loginTitle", "Login");
    this.define("username", "Benutzername");
    this.define("password", "Passwort (optional)");
    this.define("successfulLoginTitle", "Erfolgreich angemeldet");
    this.define("successfulLoginText", "Du bist angemeldet als ");
    this.define("failLoginTitle", "Anmelden fehlgeschlagen");
    this.define("tryAgain", "Versuchs nochmal!")
    this.define("registerTitle", "Registieren");
    this.define("repeatPassword", "Passwort wiederholen");
    this.define("passwordMisatchTitle", "Fehler");
    this.define("passwordMisatchText", "Die beiden Passwörter stimmen nicht überein. Möchtest du es nochmals probieren?");
    this.define("successfulRegistrationTitle", "Registrierung erfolgreich");
    this.define("successfulRegistrationText", "Gratulation! Du hast dich erfolgreich registiert und bist nun angemeldet als ");
    this.define("serversuccess", "ERFOLG");
    this.define("unknownuser", "Unbekannter Benutzername");
    this.define("wrongpassword", "Falsches Passwort");
    this.define("usernamealreadytaken", "Dieser Benutzername existiert bereits.")
    this.define("toomuchtext", "Das Dokument ist zu gross");
    this.define("toomuchtexthint", "Tipp: Du kannst zu jeder Aufgabe eine separate Lösung speichern");
    this.define("Ihaveread", "Ich habe die ");
    this.define("datenschutz", "Datenschutzerklärung");
    this.define("readandaccepted", "gelesen und bin damit einverstanden");
    this.define("documentexists", "Dokument existiert bereits");
    this.define("overwrite", "Möchtest du es überschreiben?");
    this.define("writtensuccessfully", "Dokument erfolgreich gespeichert");
  }

  private defineMissingOrIncorrectBrackets(type1, type2, type3, type4, type5, type6, commandname) {
    if (commandname === "NONE") {
      this.define(type1, "Fehlende rechte Klammer ']'");
      this.define(type2, "Fehlende linke Klammer '['");
      this.define(type3, "Fehlende Klammern '[]'");
      this.define(type4, "Falsche rechte Klammer, verwende ']' stattdessen");
      this.define(type5, "Falsche linke Klammer, verwende '[' stattdessen");
      this.define(type6, "Falsche Klammern, verwende '[]' stattdessen");
    } else {
      this.define(type1, "Fehlende rechte Klammer ']' bei '" + commandname + "'");
      this.define(type2, "Fehlende linke Klammer '[' bei '" + commandname + "'");
      this.define(type3, "Fehlende Klammern '[]' bei '" + commandname + "'");
      this.define(type4, "Falsche rechte Klammer bei '" + commandname + "', verwende stattdessen ']'");
      this.define(type5, "Falsche linke Klammer bei '" + commandname + "', verwende stattdessen '['");
      this.define(type6, "Falsche Klammern bei '" + commandname + "', verwende stattdessen '[]'");
    }
  }

  /*//------------------------------------
  // Strings related to LOGIN
  *///------------------------------------

  private defineLoginStrings() {
    this.define("notingtosave", "Nichts zu speichern? \n Dein Editor links ist leer...");
    this.define("howtosave", "Wie möchtest du speichern?");
    this.define("save", "Speichern");
    this.define("locally", "Lokal");
    this.define("online", "Online");
    this.define("load", "Programme laden");
    this.define("noconnection", "Verbindung fehlgeschlagen");
    this.define("yourcode", "Dein persönlicher ZUGANGSCODE. Notiere ihn um von überall auf deine Programme zugreifen zu können.");
    this.define("filename", "Name meiner Datei:");
    this.define("login", "Login: ");
    this.define("chapterx", "Kapitel X Aufgabe Y");
    this.define("loadprogram", "Lade Programmname:");
    this.define("chooseprogram", "Wähle ein Programm");
    this.define("incorrectpassword", "Zugangscode falsch");
    this.define("loginsuccess", "Erfolgreich angemeldet");
    this.define("youcanloadandstore", "Dateien online speichern/laden "+ "\u2192" +" im Menu");
    this.define("code", "Zugangscode");
    this.define("iamnew", "Ich bin neu...");
    this.define("logoutsuccess", "Erfolgreich abgemeldet");
  }

  //string for "there are too many arguments after command xy"
  tooManyValuesAfter(keyword, command) {
    if (command === "NONE") {
      this.define(keyword, "Zu viele Parameter nach: ");
    } else {
      this.define(keyword, "Zu viele Parameter nach '" + command + "'");
    }
  }

  //string for "there are too few arguments after command xy"
  tooFewValuesAfter(keyword, command) {
    if (command === "NONE") {
      this.define(keyword, "Fehlender Parameter nach:");
    } else {
      this.define(keyword, "Fehlender Parameter nach '" + command + "'");
    }
  }

  /*//-----------------------------------------------------------------------------------------------
  // IMPORTNAT: FROM HERE ON ALL STRINGS ARE STATIC. NO TRANSLATION REQUIRED.
  *///-----------------------------------------------------------------------------------------------

  //populate all bracket-related errors (missing, wrong, left, right or both) in general, colors, print, strings, while
  private populateBracketErrors(stringForColorDefintion) {
    this.defineMissingOrIncorrectBrackets("rgbMissingRightBr", "rgbMissingLeftBr", "rgbMissingBothBr", "rgbWrongRightBr", "rgbWrongLeftBr", "rgbWrongParentheses", stringForColorDefintion);
    this.defineMissingOrIncorrectBrackets("blockMissingRightBr", "blockMissingLeftBr", "blockMissingBothBr", "blockWrongRightBr", "blockWrongLeftBr", "blockWrongBrackets", "NONE");
    this.defineMissingOrIncorrectBrackets("printMissingRightParen", "printMissingLeftParen", "printMissingBothParen", "printWrongRightParen", "printWrongLeftParen", "printWrongParen", "print");
    this.defineMissingOrIncorrectBrackets("quotedstringMissingRightBr", "quotedstringMissingLeftBr", "quotedstringMissingBothBr", "quotedstringWrongRightBr", "quotedstringWrongLeftBr", "quotedstringWrongBrackets", "NONE");
    this.defineMissingOrIncorrectBrackets("whileMissingRightParen", "whileMissingLeftParen", "whileMissingBothParen", "whileWrongRightParen", "whileWrongLeftParen", "whileWrongParen", "print");
  }

  populateMissingOrExcessiveArguments() {
    //too few or too many arguments after built-in commands
    this.tooManyValuesAfter("fdManyArgs", "fd");
    this.tooFewValuesAfter("fdNoArgs", "fd");
    this.tooManyValuesAfter("bkManyArgs", "bk");
    this.tooFewValuesAfter("bkNoArgs", "bk");
    this.tooManyValuesAfter("rtManyArgs", "rt");
    this.tooFewValuesAfter("rtNoArgs", "rt");
    this.tooManyValuesAfter("ltManyArgs", "lt");
    this.tooFewValuesAfter("ltNoArgs", "lt");
    this.tooManyValuesAfter("csManyArgs", "cs");
    this.tooManyValuesAfter("ctManyArgs", "ct");
    this.tooManyValuesAfter("puManyArgs", "pu");
    this.tooManyValuesAfter("pdManyArgs", "pd");
    this.tooManyValuesAfter("peManyArgs", "pe");
    this.tooManyValuesAfter("pptManyArgs", "ppt");
    this.tooManyValuesAfter("htManyArgs", "ht");
    this.tooManyValuesAfter("stManyArgs", "st");
    this.tooManyValuesAfter("setscManyArgs", "setsc");
    this.tooFewValuesAfter("setscNoArg", "setsc");
    this.tooManyValuesAfter("setxManyArgs", "setx");
    this.tooFewValuesAfter("setxNoArg", "setx");
    this.tooManyValuesAfter("setyManyArgs", "sety");
    this.tooFewValuesAfter("setyNoArg", "sety");
    this.tooManyValuesAfter("randomManyArgs", "random");
    this.tooFewValuesAfter("randomNoArg", "random");
    this.tooManyValuesAfter("sinManyArgs", "sin");
    this.tooFewValuesAfter("sinNoArg", "sin");
    this.tooManyValuesAfter("cosManyArgs", "cos");
    this.tooFewValuesAfter("cosNoArg", "cos");
    this.tooManyValuesAfter("tanManyArgs", "tan");
    this.tooFewValuesAfter("tanNoArg", "tan");
    this.tooManyValuesAfter("arcsinManyArgs", "arcsin");
    this.tooFewValuesAfter("arcsinNoArg", "arcsin");
    this.tooManyValuesAfter("arccosManyArgs", "arccos");
    this.tooFewValuesAfter("arccosNoArg", "arccos");
    this.tooManyValuesAfter("arctanManyArgs", "arctan");
    this.tooFewValuesAfter("arctanNoArg", "arctan");
    this.tooManyValuesAfter("absManyArgs", "abs");
    this.tooFewValuesAfter("absNoArg", "abs");
    this.tooManyValuesAfter("sqrtManyArgs", "sqrt");
    this.tooFewValuesAfter("sqrtNoArg", "sqrt");
    this.tooManyValuesAfter("logManyArgs", "log");
    this.tooFewValuesAfter("logNoArg", "log");
    this.tooManyValuesAfter("waitManyArgs", "wait");
    this.tooFewValuesAfter("waitNoArg", "wait");
    this.tooManyValuesAfter("circleManyArgs", "circle");
    this.tooFewValuesAfter("circleNoArg", "circle");
    this.tooManyValuesAfter("setheadingManyArgs", "setheading");
    this.tooFewValuesAfter("setheadingNoArg", "setheading");
    this.tooManyValuesAfter("setpcManyArgs", "setpc");
    this.tooManyValuesAfter("setpwManyArgs", "setpw");
    this.tooFewValuesAfter("setpwNoArg", "setpw");
    this.tooManyValuesAfter("printManyArgs", "print");
    this.tooFewValuesAfter("printNoArg", "print");
    this.tooManyValuesAfter("makeManyVals", "make");
    this.tooManyValuesAfter("homeManyArgs", "home");
    this.tooManyValuesAfter("stopManyArgs", "stop");
    this.tooManyValuesAfter("setxyManyArgs", "setxy");
    this.tooManyValuesAfter("powerManyArgs", "power");
    this.tooManyValuesAfter("washManyArgs", "wash");
    this.tooManyValuesAfter("modManyArgs", "mod");

    //too few or too many arguments after user-defined commands
    this.tooManyValuesAfter("procCallTooManyArgs", "NONE");
    this.tooFewValuesAfter("procCallNotEnoughArgs", "NONE");
  }

  populateStaticStrings() {
    //these strings are static and do not need to be translated ever
    this.define("XLogoOnline", "XLogoOnline");
    this.define("XLogoOnlineColor", "#39456B");
  }

  //populate hashmap with key-value pairs for the given language. Keys will be same in all languages
  define(key: string, value: string) {
    this.lang[key] = value;
  }

  getLang() {
    return this.lang;
  }

}



// WEBPACK FOOTER //
// ./src/app/languages/german.service.ts